module.exports = __webpack_public_path__ + "img/other.dc2ae38a.svg";